export default {
    columns: [
      {
        field: "company_id",
        label:"wkt.admin.qbuilder.model.company.id.text",
        text:"wkt.admin.qbuilder.model.company.id.text",
        weight: 999
      },{
        field: "employee_id",
        label:"wkt.admin.qbuilder.model.employee_id.id.text",
        text:"wkt.admin.qbuilder.model.employee_id.id.text",
        weight: 998
      },
    ]
}